import React, { Component } from 'react';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import logo from '../images/alumsumlogo.png';
import betaLogo from '../images/alumsumlogotm.png';
import Group8 from '../art/images/stepper 3.png';
import './onboarding.css';
import {withRouter, Link} from "react-router-dom";

class OnboardingOthers2 extends Component{
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    emptyItem = {
        university: '',
        graddate: '',
        major: '',
    };

    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state = {
            item: this.emptyItem,
            csrfToken: cookies.get('XSRF-TOKEN')
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = {...this.state.item};
        item[name] = value;
        this.setState({item});
    }
    async handleSubmit(event) {
        event.preventDefault();
        const {item, csrfToken} = this.state;

        await fetch('/user' + (item.id ? '/' + item.id : ''), {

            method: (item.id) ? 'PUT' : 'POST',
            headers: {
                'X-XSRF-TOKEN': csrfToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(item),
            credentials: 'include'
        });
        this.props.history.push('/user');
    }
    render(){
        const {item} = this.state;
        item.enabled = true;
        return(
            <div>
                <Link to="/"><img src={betaLogo} alt="logo" className="responsiveLogo"/></Link>

                <div className="stepperline">
                    <img src={Group8} className="responsive" alt ="group 8"/>
                    <br>
                    </br>
                    <div className="onboardothersrectangle">
                        <div className="This-additional-info">
                            <p>This additional info helps us provide you tailored recommendations
                                and comparisons. Providing this is optional and can be done later.
                            </p>
                        </div>
                        <div className="This-additional-info-questions">
                            <form onSubmit={this.handleSubmit}>
                            <label for="whereSchool" className="currentjob">Where did you go to school (undergrad)?</label>
                                <input type="text" name="whereSchool" placeholder="University..." className="salary" 
                                    value={item.university || ''} onChange={this.handleChange} />
                                <label for="whenGraduate" className="currentjob">When did you graduate?</label>
                                <input type="text" name="gradDate" placeholder="e.g. 1997" className="salary" 
                                    value={item.graddate || ''} onChange={this.handleChange}/>
                                <label for="major" className="currentjob">What was your major?</label>
                                <input type="text" name="major" placeholder="Major.." className="salary"
                                    value={item.major || ''} onChange={this.handleChange}/>
                                <div className="buttonContainer">
                                    <Link to="/alumsum/onboardingothers3">
                                    <button className="backbutton" type="submit">Next</button>
                                    </Link>
                                    <Link to="/alumsum/user">
                                        <button className="backbutton" type="submit">Skip Now</button>
                                    </Link>
                                </div>
                            </form>
                            <table>
                                <td>
                                    {/* <button className="backbutton3" type="submit">update</button> */}
                                </td>
                            </table>
                        </div>

                        <a className="skipnow" href="/alumsum/users">Skipnow</a>

                    </div>
                </div>
            </div>
        );
    }
}
export default withCookies(withRouter(OnboardingOthers2));